import { render, staticRenderFns } from "./BaseSelectInput.vue?vue&type=template&id=064a8ec6&scoped=true&"
import script from "./BaseSelectInput.vue?vue&type=script&lang=js&"
export * from "./BaseSelectInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064a8ec6",
  null
  
)

export default component.exports